export function createClientIdempotencyKey() {
  const randomUUID = typeof crypto !== 'undefined' ? (crypto as Crypto & { randomUUID?: () => string }).randomUUID : undefined;
  if (randomUUID) return randomUUID.call(crypto);
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}
